// src/views/qr-display.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BACKEND_BASE_URL } from "../config/appUrls";
import "./common-view.css";

export default function QrDisplay() {
  const { t } = useTranslation();
  const { code } = useParams();
  const [qrData, setQrData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchQrData = async () => {
      try {
        const res = await fetch(`${BACKEND_BASE_URL}/api/qrcodes/public/${encodeURIComponent(code)}`);
        if (!res.ok) throw new Error(t("qrDisplay.notFoundOrExpired", "QR link not found or has expired."));
        
        const data = await res.json();
        setQrData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    
    fetchQrData();
  }, [code, t]);

  if (loading) return (
    <div className="view-page">
      <div className="view-card" style={{ textAlign: "center", padding: "50px" }}>
        {t("qrDisplay.loading", "Loading details...")}
      </div>
    </div>
  );

  if (error) return (
    <div className="view-page">
      <div className="view-card" style={{ textAlign: "center", padding: "50px", color: "red" }}>
        <h2>{t("qrDisplay.errorTitle", "Oops!")}</h2>
        <p>{error}</p>
      </div>
    </div>
  );

  const payload = qrData?.payload || {};

  return (
    <div className="view-page" style={{ alignItems: "center", justifyContent: "center" }}>
      <div className="view-card" style={{ maxWidth: "500px", width: "100%", padding: "30px" }}>
        <h2 style={{ marginBottom: "5px", color: "#0f172a" }}>{qrData.title}</h2>
        <p style={{ color: "#64748b", marginBottom: "25px" }}>{qrData.objective}</p>

        <div style={{ background: "#f8fafc", borderRadius: "8px", padding: "20px", border: "1px solid #e2e8f0" }}>
          {Object.entries(payload).map(([key, value]) => {
            if (key === "stripe_url" || key === "payment_link") return null;
            
            return (
              <div key={key} style={{ marginBottom: "15px", borderBottom: "1px solid #e2e8f0", paddingBottom: "10px" }}>
                <div style={{ fontSize: "12px", color: "#64748b", textTransform: "uppercase", fontWeight: "bold" }}>
                  {key.replace(/_/g, " ")}
                </div>
                <div style={{ fontSize: "16px", color: "#0f172a", marginTop: "4px" }}>
                  {value}
                </div>
              </div>
            );
          })}
        </div>

        {payload.payment_link && (
          <a 
            href={payload.payment_link} 
            style={{
              display: "block",
              width: "100%",
              background: "#2563eb",
              color: "#ffffff",
              padding: "15px",
              textAlign: "center",
              borderRadius: "8px",
              fontWeight: "bold",
              textDecoration: "none",
              marginTop: "25px",
              boxSizing: "border-box"
            }}
          >
            💳 {t("qrDisplay.payViaStripe", "Pay Securely via Stripe")}
          </a>
        )}
      </div>
    </div>
  );
}